import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  max-width: 100%;
  height: 100vh;
  flex-direction: column;
  flex-wrap: nowrap;
  @media (min-width: 760px) {
    width: 420px;
    margin: 0 auto;
  }
`;

export const HeaderContainer = styled.div``;

export const Header = styled.div`
  display: flex;
  flex-wrap: wrap;
  background: ${(props) => props.theme.palette.primary.main};
  color: ${(props) => props.theme.palette.primary.contrastText};
  font-family: 'Gibson';
  text-align: center;
  padding: 20px;
  margin: 0 20px;
  justify-content: center;
  border-bottom: 1px solid ${(props) => props.theme.palette.lightTransparency};
  @media (min-width: 760px) {
    min-width: 100%;
    margin: 0px;
  }
`;

export const NotFoundBackgroundHeader = styled.div`
  width: 100%;
  content: ' ';
  background: ${(props) => props.theme.palette.primary.main};
  height: ${(props) => props.BackgroundHeight || 'unset'};
  margin-bottom: -${(props) => props.BackgroundHeight || 'unset'};
`;

export const ContainerImageNotFound = styled.div`
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-content: center;
  flex-direction: column;
  text-align: center;
  img {
    width: 60%;
    padding-top: 30%;
    align-self: center;
  }
`;

export const NotFoundTitle = styled.div`
  font-size: 28px;
  color: ${(props) => props.theme.palette.primary.contrastText};
  font-weight: bold;
  text-align: center;
  margin-top: 20px;
`;

export const NotFoundSubtitle = styled.div`
  font-size: 18px;
  padding: 20px;
`;
